module.exports = __webpack_public_path__ + "img/ccl_gallery6.6dfb6ffe.jpg";